<template lang="pug">
  include ./../../../../mixins
  validation-observer(
    ref="observer"
    tag="form"
    class="form"
  )
    +b.ug-row--apearance_spaced.--space_md.--align_end-md
      +b.ug-cell.ug-cols--12.--6-md
        +b.control-cabinet
          +e.label Password
          +e.element--centered Password
      +b.ug-cell.ug-cols--12.--6-md
        toggle-mixin-modal(
          component-name="PasswordChange"
        )
          template(
            #default="{ handler }"
          )
            +b.button--height_xl.BUTTON-BEMTO(
              @event="handler"
            ) CHANGE PASSWORD
</template>

<script>
export default {
  name: 'PasswordPanel',
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/panels/PasswordPanel.vue